import { css } from "@emotion/css";
import React, { ReactNode } from "react";

interface WarningBoxProps {
  title: string;
  publishedDate?: string;
  children: ReactNode;
}

const WarningBox: React.FC<WarningBoxProps> = ({ title, publishedDate, children }) => {
  return (
    <div className={"mb-6 box " + borderLeftColor}>
      <h3 className="is-size-6 has-text-weight-semibold has-text-danger">⚠️ {title}</h3>
      <div className="is-size-7 py-4">{children}</div>
      {publishedDate && <p className="is-size-8 has-text-grey">Publiceret: {publishedDate}</p>}
    </div>
  );
};
const borderLeftColor = css`
  border-left: 4px solid #ff3860;
`;

export default WarningBox;
